<template>
  <div>
    <p><strong>{{ data.start }} - {{ data.end }}</strong></p>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading && data.report">
      <p>Всего: <strong>{{ data.report.totalOrders }}</strong></p>
      <p>Оплачены: <strong>{{ data.report.closedOrder.total }}</strong></p>
      <p>На сумму: <strong>{{ data.report.closedOrder.totalSum }}</strong></p>
      <p>Конверсия: <strong>{{ data.report.closedOrder.conversion }}%</strong></p>
      <p>Средний чек: <strong>{{ data.report.closedOrder.avaragePrice }}</strong></p>
    </template>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['data', 'updateData'],
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.getData();
  },
  watch: {
    'data': {
      handler: function (val, oldVal) {
        this.getData();
      },
      deep: true,
    }
  },
  methods: {
    async getData() {
      if (this.data.report) return;
      this.loading = true;
      const {data} = await api.post('/reports/conversion', {
        range: this.data
      });
      if (data.success) {
        const reportData = {
          totalOrders: (data.closedOrders.total_record ?? 0) + (data.notClosedOrders.total_record ?? 0),
          closedOrder: {
            total: (data.closedOrders.total_record ?? 0),
            totalSum: data.closedOrders.totalPrice ?? 0
          }
        };
        reportData.closedOrder.conversion = Math.round(reportData.closedOrder.total * 100 / (reportData.totalOrders || 1));
        reportData.closedOrder.avaragePrice = Math.round(reportData.closedOrder.totalSum / (reportData.closedOrder.total || 1));
        this.data.report = reportData;
        if (this.updateData) this.updateData();
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}
</style>
